import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({ label: { color: theme.palette.primary.main, } }));
